import { render, staticRenderFns } from "./SideBarApplications.vue?vue&type=template&id=463d2b18"
import script from "./SideBarApplications.vue?vue&type=script&lang=js"
export * from "./SideBarApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports